export function getMimeTypeByFormat(format, fallback = "application/pdf") {
    if (!format) return fallback;
    switch (format.toLowerCase()) {
        case "pdf": return "application/pdf";
        case "jpg":
        case "jpeg": return "image/jpeg";
        case "png": return "image/png";
        case "gif": return "image/gif";
        case "doc": return "application/msword";
        case "docx": return "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
        case "xls": return "application/vnd.ms-excel";
        case "xlsx": return "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        case "txt": return "text/plain";
        default: return fallback;
    }
}

export const fileTypes = [
    { value: "KEY_NOMINA", label: "Nómina" },
    { value: "KEY_CONTRATO", label: "Contrato" },
    { value: "KEY_OTRO", label: "Otro" },
];
